<template>
  <v-row justify="center">
    <v-dialog v-model="dialog.active" persistent width="450">
      <v-card>
        <v-card-title class="headline" style="word-break: normal">
          {{ dialog.title }}</v-card-title
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="onDisagree">{{
            dialog.deny
          }}</v-btn>
          <v-btn color="primary" text @click="onAgree">{{
            dialog.accept
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
export default {
  props: {
    dialog: {
      type: Object,
      default: Object,
    },
  },
  methods: {
    onAgree() {
      this.$emit("save", { data: this.dialog, action: true });
    },
    onDisagree() {
      this.$emit("save", { data: this.dialog, action: false });
    },
  },
};
</script>
<style scoped>
.v-card__text,
.v-card__title {
  word-break: normal;
}
</style>
